import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../../components/CommonSidebar";
import focusImage from "../../assets/focus.jpg";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const FocusAreasPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="3" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1, 
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%",
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={focusImage}
                alt="Focus Areas"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>
             

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At <strong>Yalla Nellab</strong>, we channel our energy and
                resources into areas where sports can make the most meaningful
                impact. Our focus areas include:
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>1. Community Engagement</strong> <br />
                We design and support events, festivals and tournaments that
                bring people together. By activating neighborhoods and schools,
                we create opportunities for everyone to play, connect and grow.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>2. Education & Skills Development</strong> <br />
                Through workshops, seminars and training programs, we teach
                more than just the game. We nurture teamwork, leadership,
                discipline and resilience—skills that extend beyond the field.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>3. Accessibility & Inclusion</strong> <br />
                We believe sports should be available to everyone, regardless of
                age, background, or ability. By removing barriers, creating safe
                spaces and offering flexible programs, we ensure that no one is
                left out of the joy of movement.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>4. Health & Wellbeing</strong> <br />
                Physical activity is essential for a healthy life. We encourage
                regular movement, exercise and active lifestyles to promote
                mental, emotional and physical wellbeing across communities.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>5. Media & Awareness</strong> <br />
                Through our digital and media platforms, we amplify the positive
                impact of sports, share inspiring stories and raise awareness
                about the benefits of active living.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>6. Sustainability & Measurable Impact</strong> <br />
                We are committed to programs that create lasting change. By
                tracking outcomes, gathering feedback and continuously improving
                our initiatives, we ensure that every effort has a meaningful
                and sustainable impact.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default FocusAreasPage;